import { DataService } from './../../../../../core.module/services/data.service';
import { sanitizeHtml } from '@angular/platform-browser/src/security/html_sanitizer';
import { OfferCodeApi } from './../../../../../shared/sdk/services/custom/OfferCode';
import { LoggerService } from './../../../../../shared/sdk/services/custom/logger.service';
import { OfferCode } from './../../../../../shared/sdk/models/OfferCode';
import { LimitedTimeOfferApi } from './../../../../../shared/sdk/services/custom/LimitedTimeOffer';
import { FireLoopRef } from '../../../../../shared/sdk';
import { LimitedTimeOffer } from './../../../../../shared/sdk/models/LimitedTimeOffer';
import { RealTime } from './../../../../../shared/sdk/services/core/real.time';
import { KanvasUserApi } from './../../../../../shared/sdk/services/custom/KanvasUser';
import { ICustomPropConfig } from './../../prop-editors.moudule/custom-prop-config.interface';
import { ScreenElementClass } from './../screen-element.class';
import { IScreenElement } from './../screen-element.interface';
import { SeLimitedTimeOfferConfig } from './se-limited-time-offer-config.class';

import {
  AfterContentInit,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  HostListener,
  Injector,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  Renderer2,
} from '@angular/core';
import { DomSanitizer, SafeStyle } from '@angular/platform-browser';
import { Bounce, Ease, Elastic, Linear, Power1, Power2, Power3, Power4, TimelineMax, TweenConfig, TweenMax } from 'gsap';
import Draggable from 'gsap/Draggable';
import * as _ from 'lodash';

import { Observer } from 'rxjs/Observer';
import { Subject } from 'rxjs/Subject';
import { Subscription } from 'rxjs/Subscription';
import * as uuidv4 from 'uuid/v4';
import * as moment from 'moment';



@Component({
  selector: 'app-se-limited-time-offer',
  templateUrl: './se-limited-time-offer.component.html',
  styleUrls: ['./se-limited-time-offer.component.css']
})
export class SeLimitedTimeOfferComponent extends ScreenElementClass implements
  IScreenElement, OnInit, OnDestroy, AfterViewInit, AfterContentInit, OnChanges {
  public elementConfig = new SeLimitedTimeOfferConfig(); // settings for this element

  public adornerSizeSub: Subscription;
  public sizeChangeObserver: Observer<any> = {
    next: (x) => {

    },
    error: (err) => {

    },
    complete: () => {

    }
  };


  public offerCodes: OfferCode[];
  public unUsedCodes: OfferCode[];
  public codesLeft: number;
  public currentPinCode: string;
  public lto: LimitedTimeOffer = new LimitedTimeOffer();
  public updatedLTOSubject$: Subject<LimitedTimeOffer> = new Subject();
  public realTimeConnectionChange$: Subscription;

  @ViewChild('ltoContainer') ltoContainer;
  @ViewChild('codesLeftContainer') codesLeftContainer;
  @ViewChild('pincodeBox') pincodeBox;

  // element props
  @HostBinding('style.background-color') get getBackgroundColor() { return this.elementConfig.backgroundColor; }


  constructor(
    public injector: Injector,
    public sanitizer: DomSanitizer,
    public elementRef: ElementRef,
    public changeDetectorRef: ChangeDetectorRef,
    public ltoApi: LimitedTimeOfferApi,
    public offerCodeApi: OfferCodeApi,
    public logger: LoggerService,
    public dataService: DataService,
    public renderer: Renderer2
  ) {
    super(sanitizer); // initilize base class
    // get inital configs (if passed by injector)
    const startingElementConfig = this.injector.get('elementConfig');  // get commonConfig Value if injected

    if (startingElementConfig) {
      this.elementConfig.fromJson(startingElementConfig);
    }
  }

  async ngOnInit() {
    if (!this.elementConfig.ltoId) {
      await this.createLto();
    }

    this.realTimeConnectionChange$ = this.dataService.realtimeConnectionChange$.subscribe((data) => {
      if (data.connected) {
        this.startMonitoringLTO();
      }

      if (data.connecting) {

      }
    });
  }

  ngOnChanges(changes) {
    if (changes.elementConfig) {

    }
  }

  ngOnDestroy() {
    if (this.adornerSizeSub) {
      this.adornerSizeSub.unsubscribe();
    }

    if (this.realTimeConnectionChange$) {

      this.realTimeConnectionChange$.unsubscribe();
    }

  }

  async createLto() {
    // create a new LTO offer!

    const lto = await this.ltoApi.create({
      id: uuidv4(),
      ClaimPin: Math.floor((Math.random() * 10000) + 1),
      validAt: new Date(),
      invalidAt: this.addMinutes(new Date(), 5),
      OfferDescription: 'In store promo',
      offerCodes: [
        {
          code: 'your coupon code 1'
        },
        {
          code: 'your coupon code 2'
        }

      ],
      kanvasUserId: this.dataService.getCalculatedUserId()
    }).toPromise();

    await this.offerCodeApi.create({ code: 'offer code 1', limitedTimeOfferId: lto.id }).toPromise();
    await this.offerCodeApi.create({ code: 'offer code 2', limitedTimeOfferId: lto.id }).toPromise();
    await this.offerCodeApi.create({ code: 'offer code 3', limitedTimeOfferId: lto.id }).toPromise();

    this.elementConfig.ltoId = lto.id;
  }



  startMonitoringLTO() {
    this.dataService.ltoRTRef.on('change', {
      limit: 10,
      order: 'id DESC',
      where: { 'id': this.elementConfig.ltoId },
      include: 'offerCodes'
    }).subscribe((items: LimitedTimeOffer[]) => {
      this.lto = items[0];

      this.offerCodes = items[0].offerCodes;
      this.currentPinCode = items[0].ClaimPin;
      this.unUsedCodes = this.offerCodes.filter(offerCode => { return !offerCode.used; });
      this.codesLeft = this.unUsedCodes.length;
      this.changeDetectorRef.detectChanges();


      this.updatedLTOSubject$.next(this.lto);
      // console.log(items);
    }, err => {
      console.log('error watching lto', err);
    });


  }
  addMinutes(date, minutes) {
    return moment(date).add(minutes, 'm').toDate();
  }

  ngAfterContentInit() {

  }

  ngAfterViewInit() {

  }

  getCustomProperties() {

    const userAdjustableProps: ICustomPropConfig[] = new Array;

    const ltoEditor: ICustomPropConfig = {
      type: 'pe-lto',
      name: 'Limited Time Offer',
      propPath: '',
      defaultValue: '',
      tooltip: 'Configure limited time offer object',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    const backgroundColor: ICustomPropConfig = {
      type: 'pe-colorpicker',
      name: 'Background Color',
      propPath: 'elementConfig.backgroundColor',
      defaultValue: null,
      tooltip: 'the color behind the object',
      showDefaultReset: true,
      groupName: null,
      settings: {
      }
    };

    userAdjustableProps.push(ltoEditor);
    userAdjustableProps.push(backgroundColor);

    return userAdjustableProps;
  }




}




// WEBPACK FOOTER //
// ./src/app/backend-main.module/pages/designer.module/screen-elements.module/se-limited-time-offer/se-limited-time-offer.component.ts